var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading } from '@digitools/honest-react/dist/lib/components/Heading';
import { Link } from '@digitools/honest-react';
import styled from 'styled-components';
import themes from '@digitools/honest-react/dist/lib/theming/themes';
import useTealium from '../hooks/useTealium';
import { TEALIUM_EVENT } from '../constants/tealiumConstants';
var NeedHelp = function () {
  //TODO: This should be added to Honest
  var StyledLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: 500;\n  "], ["\n    font-weight: 500;\n  "])));
  var trackEvent = useTealium().trackEvent;
  return _jsxs("div", {
    children: [_jsx("hr", {
      style: {
        width: '100%',
        height: '0.1rem',
        margin: 0,
        backgroundColor: '#37424A'
      }
    }), _jsxs(Heading, __assign({
      elemType: 'h4',
      theme: themes.lincoln,
      style: {
        textAlign: 'center',
        color: '#37424A',
        marginBottom: '1rem'
      }
    }, {
      children: [_jsx("strong", {
        children: "Need technical assistance?"
      }), " Call us at", ' ', _jsx(StyledLink, __assign({
        href: 'tel:+1-877-321-1014',
        onClick: function () {
          trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
            event_name: 'Lincoln Dental Provider Portal Support Phone Number',
            event_type: TEALIUM_EVENT.EVENT_TYPE.REGISTRATION
          });
        }
      }, {
        children: "1-877-321-1014"
      })), ' ', "or email us at", ' ', _jsx(StyledLink, __assign({
        href: 'mailto:LincolnDentalProviderPortal_support@lfg.com',
        onClick: function () {
          trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
            event_name: 'Lincoln Dental Provider Portal Support Email',
            event_type: TEALIUM_EVENT.EVENT_TYPE.REGISTRATION
          });
        }
      }, {
        children: "LincolnDentalProviderPortal_support@lfg.com"
      }))]
    })), _jsx("hr", {
      style: {
        width: '100%',
        height: '0.30rem',
        margin: 0,
        backgroundColor: '#AD112B'
      }
    })]
  });
};
export default NeedHelp;
var templateObject_1;